module.exports = "https://static.wagwalking.com/_next/static/images/callum-turner-a45215fcde374ddd441e6a7ccd2b888f.png";